<template>
  <div>
    <CCard class="sp_card">
      <!-- <CCardHeader class="sticky-top">
        <CRow>
          <CCol class="header-title">
            <span>リバティーリゾート会員アプリ</span>
            <h2>会員登録</h2>
          </CCol>
        </CRow>
      </CCardHeader> -->
      <!--m-0 mb-0 mt-5 -->
      <CCardBody class="p-4 card-body">
        <PrivacyPolicy />
      </CCardBody>
      <!-- <CCardFooter class="fixed-bottom">
        Liberty Resort

      </CCardFooter> -->
    </CCard>
    <!-- dialog section ▌↓↓ -->
  </div>
</template>

<script>
export default {
  name: "AppPrivacyPolicy",
  components: {},
  data() {
    return {
      GUserId: "",
    };
  },

  methods: {
    closeMe() {
      window.open("", "_self", "");
      window.close();
    },
  },
  beforeMount() {},
};
</script>

<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  .card-header {
    border: none;
    border-radius: 0;
    padding-top: 1%;
    padding-bottom: 1%;
    .header-title {
      text-align: center;

      span {
        font-size: 0.9rem;
        line-height: 0.9rem;
      }
      h2 {
        font-size: 1.4rem;
      }
    }

    color: #ffffff;
    background: #a17602;
  }
  .card-body {
    .terms_and_conditions {
      max-height: none;
      border: none;
      padding: 0;
    }
  }
  .card-footer {
    border: none;
    border-top: 2px solid #a17602;
    padding: 1%;
    text-align: center;
  }
}
</style>

